import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { data } from 'jquery';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private domSanitizer: DomSanitizer) {
    ConfigService.Sanatizer = domSanitizer;
  }

  static Sanatizer: DomSanitizer;

  static Config: ConfigItem[] = [];

  static dyns: any[] = [];

  static str = new BehaviorSubject<boolean>(false);

  public SetConfig(items: ConfigItem[]): void {
    ConfigService.Config = items;
    for (var i = 1; i < 5; i++) {
      if (ConfigService.GetItem('homedyn' + (i))?._view)
        ConfigService.dyns[i - 1] = {
          title: ConfigService.GetItem('homedyn' + (i))?.txt,
          icon: ConfigService.GetItem('homedyn' + (i))?.icon,
          number: parseInt(ConfigService.GetItem('homedyn' + (i))?.param1),
          img: ConfigService.GetItem('homedyn' + (i))?.param2 === '1'
        };
    }
    ConfigService.str.next(!ConfigService.str.value);
  }

  static GetItem(id: string): ConfigItem {
/*    console.log(ConfigService.Config)*/
    return ConfigService.Config.find(x => x.idconf === id);
  }
}

export interface ConfigItem {
  idconf: string;
  description: string;
  _view: boolean;
  style: string;
  class: string;
  txt: string;
  icon: string;
  param1: string;
  param2: string;
  param3: string;
  param4: string;
}
